export default {
  PAYROLL_OPENED: 'payroll:payroll_opened',
  CLOSE_BULK_EMAIL_PAYSLIPS_MODAL: 'payroll:close_bulk_email_payslips_modal',
  PAYROLL_ONBOARDING_FINISHED: 'payroll:onboarding_finished',
};

export const PARTNER_IFRAME_EVENTS = {
  OPEN_BULK_EMAIL_PAYSLIPS_MODAL: 'payroll:open_bulk_email_payslips_modal',
};
